export default {
  BASE_URL: process.env.REACT_APP_SERVER_URL_BASE ?? 'https://api.sandbox.neoconecta.com'
};